const KEY = "aitu_schedule_map_focus_room_v1";

export function setPendingRoom(room: string) {
  const r = (room || "").trim();
  if (!r) return;
  localStorage.setItem(KEY, r);
}

export function consumePendingRoom(): string | null {
  const r = (localStorage.getItem(KEY) || "").trim();
  if (!r) return null;
  localStorage.removeItem(KEY);
  return r;
}
